module.exports = __webpack_public_path__ + "static/media/validation-error.d469ba90.svg";